import api from '../';

class LonerBonusGamesApi {
    static getImages(params) {
        return api.axios.get('/loner-bonus-games/images', { params }).then(({ data }) => data);
    }

    static getMinImages() {
        return api.axios.get('/loner-bonus-games/min-images').then(({ data }) => data);
    }
}

export default LonerBonusGamesApi;
